export default "__VITE_ASSET__DpLrSWpE__"